import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@p2p/shared/utils';
import { Observable } from 'rxjs';

import { PaymentMethodsPreassignedResponse, PaymentMethodsResponse } from '../entities';

@Injectable({ providedIn: 'root' })
export class PaymentMethodsDataService {
    private readonly http = inject(HttpClient);

    private readonly baseUrl = '/rest/payment-methods';

    getPaymentMethods(): Observable<PaymentMethodsResponse> {
        return this.http.get<PaymentMethodsResponse>(`${environment.apiUrl}${this.baseUrl}`);
    }

    getPaymentMethodsPreassigned(): Observable<PaymentMethodsPreassignedResponse> {
        return this.http.get<PaymentMethodsPreassignedResponse>(`${environment.apiUrl}${this.baseUrl}/preassigned`);
    }
}
